import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './LoginPage.css'; // Custom CSS for additional styling

const LoginPage = () => {
  const [mobile, setMobile] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!mobile || mobile.length !== 10) {
      alert('Please enter a valid 10-digit mobile number.');
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('mobile', mobile);

      const response = await fetch('https://singlewindowsecurities.com/rest3/web_login_api', {
        method: 'POST',
        body: formData,
        // Note: Don't set Content-Type header when using FormData
        // The browser will set it automatically with the correct boundary
      });
      const result = await response.json();
      console.log(result);
      
      if (result.status==0) {
        const { otp } = result;
        alert('OTP sent successfully.');
        navigate('/otp', { state: { uotp: otp, mobile } });
      } else {
        alert(result.msg || 'Something went wrong.');
      }
    } catch (error) {
      alert('Failed to connect to the server. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Background Gradient - Dark Golden & Black Theme */}
      <div className="bg-gradient"></div>
      
      {/* Decorative Icons */}
      <div className="decor-icon bitcoin-icon-1">
        <i className="fab fa-bitcoin"></i>
      </div>
      <div className="decor-icon dollar-icon">
        <i className="fas fa-dollar-sign"></i>
      </div>
      <div className="decor-icon exchange-icon">
        <i className="fas fa-exchange-alt"></i>
      </div>
      <div className="decor-icon bitcoin-icon-2">
        <i className="fab fa-bitcoin"></i>
      </div>

      {/* Main Content */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8 col-sm-10">
            {/* Header Section */}
            <div className="text-center mb-5 mt-5">
              <img 
                src="https://singlewindowsecurities.com/assets/images/logo.png" 
                alt="singlewindowsecurities" 
                className="img-fluid"
              /><hr/>
              <h3 className="mb-3 golden-text">Welcome Back</h3>
              <p className="text-muted opacity-75">
                Enter your registered mobile number to continue
              </p>
            </div>
            
            {/* Login Form */}
            <form onSubmit={handleSubmit}>
              {/* Mobile Input */}
              <div className={`form-group mb-4 input-group ${mobile.length === 10 ? 'valid' : ''}`}>
                <div className="input-group-prepend">
                  <span className="input-group-text bg-dark-golden border-golden">
                    <i className="fas fa-mobile-alt fa-2x golden-text"></i>
                  </span>
                </div>
                <input
                  type="tel"
                  className="form-control bg-dark-card border-golden text-white"
                  placeholder="Mobile Number"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  maxLength="10"
                />
              </div>
              
              {/* Login Button */}
              <button 
                type="submit" 
                className={`btn btn-golden btn-block btn-lg mb-4 ${mobile.length !== 10 ? 'disabled' : ''}`}
                disabled={loading || mobile.length !== 10}
              >
                {loading ? (
                  <div className="spinner-border spinner-border-sm text-dark" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                ) : (
                  <>
                    SEND OTP <i className="fas fa-arrow-right ml-2"></i>
                  </>
                )}
              </button>
              
              {/* Divider */}
              <div className="divider d-flex align-items-center mb-4">
                <div className="divider-line bg-golden"></div>
                <span className="px-3 text-muted">OR</span>
                <div className="divider-line bg-golden"></div>
              </div>
              
              {/* Sign Up Link */}
              <div className="text-center">
                <p className="text-muted">
                  Don't have an account?{' '}
                  <Link to="/register" className="golden-text font-weight-bold">
                    Register Now
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  );
};

export default LoginPage;